var _path, _path2, _path3, _path4;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgBread = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M36.6667 10.8333C36.6667 6.69165 33.3083 3.33331 29.1667 3.33331C16.6667 3.33331 5 15 5 29.1666C5 33.3083 8.35833 36.6666 12.5 36.6666C28.3333 36.6666 36.6667 23.3333 36.6667 10.8333Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.065 10.935C24.5533 11.4234 25.1933 11.6667 25.8333 11.6667C26.4733 11.6667 27.1133 11.4234 27.6017 10.935C28.5783 9.96002 28.5783 8.37502 27.6017 7.40002C26.2183 6.01669 24.8867 4.95002 23.63 4.12335C21.5233 4.70335 19.4933 5.58669 17.5967 6.75169C19.1983 7.19335 21.43 8.29835 24.065 10.935Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.34668 14.775C11.44 15.0767 14.4 16.3333 17.0567 20.5083C17.535 21.2567 18.3433 21.6667 19.1683 21.6667C19.6283 21.6667 20.0933 21.54 20.51 21.2767C21.6733 20.535 22.0167 18.99 21.2767 17.825C18.5883 13.5983 15.555 11.5083 12.8383 10.515C11.5467 11.805 10.365 13.2233 9.34668 14.775Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.80659 19.7367C6.18992 21.315 5.72326 22.965 5.41992 24.6734C6.51326 25.3367 7.73826 26.275 9.06492 27.6017C9.55326 28.09 10.1933 28.3334 10.8333 28.3334C11.4733 28.3334 12.1133 28.09 12.6016 27.6017C13.5783 26.6267 13.5783 25.0417 12.6016 24.0667C10.5249 21.99 8.57159 20.6334 6.80659 19.7367Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBread, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bread.218ab7ed.svg";
export { ForwardRef as ReactComponent };